export default __webpack_public_path__ + "static/media/human.2f6f733d.svg";